module.exports = __webpack_public_path__ + "assets/images/USD001.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USD001.png
// module id = 1446
// module chunks = 1